import { RcraInfoFederalWasteGeneratorStatus } from "generated-graphql/graphql";

/**
 * Identifies one exceedance for the lifecycle mutations, carrying the current
 * status jump so the server can snapshot it when materializing the row.
 */
export type ExceedanceKey = {
  facilityId: string;
  source: string;
  periodStart: string;
  reportedFederalStatus: RcraInfoFederalWasteGeneratorStatus | null;
  calculatedFederalStatus: RcraInfoFederalWasteGeneratorStatus | null;
};

/**
 * Queries every exceedance lifecycle mutation must refresh: the dashboard grid
 * and the open drawer's detail payload.
 */
export const EXCEEDANCE_REFETCH = [
  "StaffGeneratorStatusChanges",
  "GeneratorStatusExceedanceDetail",
];
